import { ChecklistEnum } from './model';

type ProjectData = {
  name: string;
  url: string;
  isJavascriptInstalled: boolean;
  isExtensionInstalled: boolean;
  isWebsiteVisited: boolean;
  javascriptInstalledOverride: boolean;
  inviteMemberOnboarding: boolean;
};

export const getOnboardingState: (
  currentProject: ProjectData
) => ChecklistEnum = ({
  name,
  url,
  isJavascriptInstalled,
  isExtensionInstalled,
  isWebsiteVisited,
  javascriptInstalledOverride,
  inviteMemberOnboarding
}) => {
  if (url === null || name === null || url === '' || name === '') {
    return ChecklistEnum.SETUP_PROJECT;
  }

  if (
    !isJavascriptInstalled &&
    !isExtensionInstalled &&
    !javascriptInstalledOverride
  ) {
    return ChecklistEnum.INSTALL_BH;
  }

  return inviteMemberOnboarding && isWebsiteVisited
    ? ChecklistEnum.INVITE_TEAM
    : ChecklistEnum.WEBSITE;
};
